import { __exports as a } from "./index152.js";
var u;
function p() {
  if (u) return a;
  u = 1;
  var i = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
  return a.parse = function(r) {
    var n = [1, 5, 6, 7, 11, 12], e = i.exec(r), t = 0;
    if (!e)
      return new Date(r);
    for (var s = 0, f; f = n[s]; s++)
      e[f] = parseInt(e[f], 10) || 0;
    e[2] = parseInt(e[2], 10) || 1, e[3] = parseInt(e[3], 10) || 1, e[2]--, e[8] = e[8] ? (e[8] + "00").substring(0, 3) : 0, e[4] === " " ? t = (/* @__PURE__ */ new Date()).getTimezoneOffset() : e[9] !== "Z" && e[10] && (t = e[11] * 60 + e[12], e[10] === "+" && (t = 0 - t));
    var d = Date.UTC(e[1], e[2], e[3], e[5], e[6] + t, e[7], e[8]);
    return new Date(d);
  }, a.is = function(r, n) {
    return typeof r != "string" || n && /^\d{4}-\d{2}-\d{2}/.test(r) === !1 ? !1 : i.test(r);
  }, a;
}
export {
  p as __require
};
//# sourceMappingURL=index133.js.map
